import { captureException } from '@sentry/react';
import type { ParsedQuery } from 'query-string';
import qs from 'query-string';

import { sanitizeUserInputForUrl } from './sanitize';
/**
 * checks if string spells "none" after being lowercased
 */
export const isNoneString = (input: any) => {
  if (typeof input !== 'string') return false;
  return input.toLowerCase() === 'none';
};

export function standardizePathName(path: string): string {
  return path.toLowerCase().replace(/\/$/, '');
}

/**
 *
 * checks if two path strings are equal case insensitive

 * @param {string} pathOne
 * @param {string} pathTwo
 * @returns {boolean} boolean
 */
export function arePathnamesEqual(pathOne: string, pathTwo: string): boolean {
  const stripTrailingSlash = (str: string) => str.replace(/\/$/, '');
  return stripTrailingSlash(pathOne.toLowerCase()) === stripTrailingSlash(pathTwo.toLowerCase());
}

/**
 * Returns the hostname from a given url string
 * @param url string
 * @returns string | null
 */
export const getHostnameFromURL = (url: string): string | null => {
  try {
    const domain = new URL(url);
    return domain.hostname;
  } catch (err) {
    captureException(err);
    return null;
  }
};

/**
 * Returns current path marketing query params
 * @returns
 */
export const parseMarketingParams = (queryString: string) => {
  const parsedParams: ParsedQuery<string> = qs.parse(queryString);
  return {
    utm_campaign: parsedParams.utm_campaign,
    utm_source: parsedParams.utm_source,
    utm_medium: parsedParams.utm_medium,
    utm_term: parsedParams.utm_term,
    utm_content: parsedParams.utm_content,
    gclid: parsedParams.gclid,
    msclkid: parsedParams.msclkid,
    cp_referral: parsedParams.cp_referral,
  };
};

/**
 * Returns the given url or path string with current query params preserved
 * @param urlPath string
 * @returns string
 */
export const getUrlPathWithPreservedQuery = (urlPath: string): string => {
  if (typeof window === 'undefined') return urlPath;
  const params = window.location.search;
  const sanitizedParams = sanitizeUserInputForUrl(params);
  const marketingParams = qs.stringify(parseMarketingParams(decodeURIComponent(sanitizedParams)));
  return `${urlPath}${marketingParams ? `?${marketingParams}` : ''}`;
};

export const isValidCurrencyText = (value: string) => {
  /*
    ^ - Matches the beginning of the string
    [0-9\b]* - Matches zero or more occurrences of digits 0-9 and backspace \b
    \.? - Matches zero or one occurrence of a period .
    [0-9\b]+ - Matches one or more occurrences of digits 0-9 and backspace \b
    $ - Matches the end of the string
  */
  const re = /^[0-9\b]*\.?[0-9\b]*$/;
  return re.test(value);
};

export const toTitleCase = (str?: string) => {
  return str && str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
